if (!customElements.get('ember-restock')) {
  customElements.define('ember-restock', class extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.email = this.form.elements.email;
      this.button = this.form.querySelector('button');
      this.status = this.querySelector('[data-restock-status]');
      this.productInfo = this.closest('product-info');
      this.generation = 0;
      this.updateVariant(this.dataset.variantId, this);
      this.submitHandler = this.submit.bind(this);
      this.form.addEventListener('submit', this.submitHandler);

      // Ember swatches change their label before the server returns the new variant.
      this.swatchHandler = (event) => {
        if (event.target.closest('[data-ember-color-swatch]')) this.reset();
      };
      this.productInfo.addEventListener('click', this.swatchHandler, true);
      this.unsubscribeSelection = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (this.productInfo.contains(data.event.target)) this.reset();
      });
      this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (String(data.sectionId) !== this.dataset.sectionId) return;
        this.updateVariant(data.variant?.id, data.html.getElementById(this.id));
      });
    }

    disconnectedCallback() {
      this.generation++;
      this.unsubscribeSelection?.();
      this.unsubscribeVariant?.();
      this.productInfo?.removeEventListener('click', this.swatchHandler, true);
      this.form?.removeEventListener('submit', this.submitHandler);
    }

    reset() {
      this.generation++;
      this.hidden = true;
      this.variant = null;
      this.pending = false;
      this.querySelector('details').open = false;
      this.form.hidden = false;
      this.email.disabled = false;
      this.button.disabled = false;
      this.button.textContent = 'Notify me';
      this.status.textContent = '';
    }

    updateVariant(id, source) {
      this.reset();
      const variants = JSON.parse(source?.querySelector('[data-restock-variants]')?.textContent || '[]');
      this.variant = variants.find((variant) => String(variant.id) === String(id));
      this.hidden = !this.variant?.eligible;
      this.querySelector('[data-restock-option]').textContent = this.variant?.title || '';
    }

    async submit(event) {
      event.preventDefault();
      if (this.hidden || !this.variant?.eligible || this.pending || !this.form.reportValidity()) return;
      const generation = this.generation;
      const variant = this.variant;
      this.pending = true;
      this.email.disabled = true;
      this.button.disabled = true;
      this.button.textContent = 'Submitting…';
      this.status.textContent = '';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(this.dataset.siteId)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
          signal: controller.signal,
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email: this.email.value.trim() } } },
                channels: ['EMAIL'],
              },
              relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variant.id}` } } },
            },
          }),
        });
        if (response.status !== 202) throw new Error('Restock request not accepted');
        if (this.generation !== generation) return;
        this.form.hidden = true;
        this.status.textContent = `You’re on the list. We’ll email you when ${variant.title} is available.`;
      } catch {
        if (this.generation !== generation) return;
        this.status.textContent = 'We couldn’t confirm your request. Please try again in a moment.';
      } finally {
        clearTimeout(timeout);
        if (this.generation === generation) {
          this.pending = false;
          this.email.disabled = false;
          this.button.disabled = false;
          this.button.textContent = 'Notify me';
        }
      }
    }
  });
}
